import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'ds-divider',
  templateUrl: './ds-divider.component.html',
  styleUrls: ['./ds-divider.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsDividerComponent {
  @Input() indent = '12px';

  @HostBinding('style.--divider-indent')
  get hostIndent(): string {
    return this.indent;
  }
}
